import React, { useState, useEffect, useContext } from "react";
import { search, fondo } from '../providers';
import Header from "../modules/Header";
import { UserContext } from '../context/UserContext';


function ClientesTB() {
    const [Cliente, setCliente] = useState([]);
    const [clientes, setClientes] = useState([]);
    const [clieFilter, setClieFilter] = useState([]);
    const [id, setId] = useState(0);
    const [user, setUser] = useContext(UserContext);
    const [tableState, setTableState] = useState(false);


    const [nombre, setNombre] = useState("");
    const [activo, setActivo] = useState(false);
    const [codigo, setCodigo] = useState("");
    const [dateFrom, setDateFrom] = useState();
    const [dateTo, setDateTo] = useState();


    const getProjects = async () => {
        await fetch("https://app-mcewan.herokuapp.com/timebilling/getClients", {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                "token": user.tokenTimeBilling
            })
        })
            .then(response => response.json())
            .then((value) => {
                console.log(value);
                setClientes(value);
                setClieFilter(value);
            })
            .catch(error => console.log(error));
    }

    useEffect(() => {
        (async () => {
            await getProjects();
        })();
        console.log(dateFrom);


        console.log(Date.parse(dateFrom));
        console.log(Date.parse("2020-03-05"));


    }, [user.tokenTimeBilling]);

    const filterById = async () => {
        setTableState(true);

        await fetch("https://app-mcewan.herokuapp.com/timebilling/getClient/" + id, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                "token": user.tokenTimeBilling
            })
        })
            .then(response => response.json())
            .then((value) => {
                const arr = [];
                console.log(value);
                arr.push(value);
                setCliente(arr);
            })
            .catch(error => console.log(error));
    }



    return (
        <div className="container_general">
            {console.log(id)}
            <img src={fondo} className='fondo' alt='mcewanfondo' />
            <Header />
            <div className="body_container">
                <div className="general-filters">
                    <form>
                        <div className="form-group">
                            <p>Nombre Cliente</p>
                            <div className="input-case">
                                <input type="text" className="search_input"
                                    value={nombre} onChange={(value) => setNombre(value.target.value)}
                                />
                            </div>
                        </div>
                        <div className="form-group">
                            <p>Codigo</p>
                            <div className="input-case">
                                <input type="text" className="search_input"
                                    value={codigo} onChange={(value) => setCodigo(value.target.value)}
                                />
                            </div>
                        </div>
                        <div className="form-group">
                            <p>Solo Activos</p>
                            <div className="input-case">
                                <input type="checkbox" className="search_input"
                                    value={activo} onChange={(value) => setActivo(value.target.checked)}
                                />
                            </div>
                        </div>
                        <div className="form-group">
                            <p>Fecha Desde</p>
                            <div style={{ width: '32%' }} className="input-case">
                                <input type="date" className="search_input"
                                    value={dateFrom} onChange={(value) => setDateFrom(value.target.value)}
                                />

                            </div>
                            <p>Fecha Hasta</p>
                            <div style={{ width: '32%' }} className="input-case">
                                <input type="date" className="search_input"
                                    value={dateTo} onChange={(value) => setDateTo(value.target.value)}
                                />

                            </div>
                        </div>
                    </form>
                </div>
                {/*<div className="filters_container">

                    <form className="search_container" onSubmit={filterById}>
                        <input type="text" placeholder="Ingrese la id del cliente" className="search_input"
                            value={id} onChange={(value) => setId(value.target.value)}
                        />
                        <button className="search_button">
                            <img src={search} className="search_img" />
                        </button>
                    </form>
                    <button className={`return_button ${clientes.length === 1 ? "" : "no_display"}`} onClick={getProjects}>
                        Volver
                    </button>
                </div> */}

                {
                    tableState === true ? (
                        <div style={{ width: 'auto', marginBottom: 30 }} className="table_card">
                            <table>
                                <tr>
                                    <th>ID</th>
                                    <th>Activo</th>
                                    <th>Código de cliente</th>
                                    <th>Creado en</th>
                                    <th>Nombre</th>
                                    <th>Asuntos</th>


                                </tr>
                                {
                                    Cliente.length > 0 ? (
                                        Cliente.map((value, index) => {
                                            return (
                                                <tr key={index} >
                                                    <td>{value.id}</td>
                                                    <td>{value.active}</td>
                                                    <td>{value.code}</td>
                                                    <td>{value.created_at}</td>
                                                    <td>{value.name}</td>

                                                    {value.agrements !== undefined ? (
                                                        value.agrements.map((value, index) => {
                                                            return <td>{value.id}</td>;
                                                        })
                                                    ) : null
                                                    }

                                                </tr>
                                            );
                                        })
                                    ) : null
                                }
                            </table>
                        </div>
                    ) : <div style={{ margin: 45 }}></div>
                }
                <div className="table_card">
                    <table>
                        <tr>
                            <th>ID</th>
                            <th>Activo</th>
                            <th>Código de cliente</th>
                            <th>Creado en</th>
                            <th>Nombre</th>
                        </tr>
                        {
                            clieFilter.length > 0 ? (
                                clieFilter.filter((val) => {
                                    if (nombre === "") {
                                        return val;
                                    } else if (val.name.toLowerCase().includes(nombre.toLowerCase())) {
                                        return val;
                                    }

                                }
                                ).filter((val) => {
                                    if (codigo === "") {
                                        return val;
                                    } else if (codigo === val.code) {
                                        return val;
                                    }
                                }).filter((val) => {
                                    if (activo === false) {
                                        return val;
                                    } else if (val.active === "1" && activo===true) {
                                        return val;
                                    }
                                }).filter((val) => {
                                    let dateCheck;
                                    let tsDate;
                                    let tsDateTo;
                                    tsDateTo = Date.parse(dateTo);
                                    tsDate = Date.parse(dateFrom);
                                    dateCheck = Date.parse(val.created_at)
                                    if (dateFrom === undefined || dateTo === undefined) {
                                        return val;
                                    } else if (dateCheck >= tsDate && dateCheck <= tsDateTo) {
                                        return val;
                                    }
                                }).map((value, index) => {
                                    return (
                                        <tr key={index} onClick={() => { setId(parseInt(value.id)); filterById() }}>
                                            <td>{value.id}</td>
                                            <td>{value.active}</td>
                                            <td>{value.code}</td>
                                            <td>{value.created_at}</td>
                                            <td>{value.name}</td>
                                        </tr>
                                    );
                                })
                            ) : null

                        }
                    </table>
                </div>
            </div>
        </div>
    );
}

export default ClientesTB;